import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import ExamListForm from "../../form/exam/ExamListForm";
import _ from "lodash";
import { StructParam } from "@/lib/form/candidate/CandidateCreateForm";
import {
  ExamCopyForm,
  ExamDeleteForm,
  ExamGetForm,
  ExamGetAllForm
} from "@/lib/form/exam/ExamListForm";
import ExamCreateForm, { ExamUpdateForm } from "@/lib/form/exam/ExamCreateForm";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import V from "@/store/vuex-store";

export class StructExamUserData extends Model {
  name = ""; //面试名称
  startDate = "";
  beginTime = ""; //开始时间
  startTiming = "";
  endDate = "";
  endTime = ""; //结束时间
  endTiming = "";
  timeLimitExam = 0; //考试时长限制（秒）
  repeatAnswer = 1; //是否允许重复面试
  noEnding = 2; //是否长期有效
  isCheckMobile = 0; //是否校验验证码
  isRandomQuestions = 0; //是否抽题组卷
  isRandomQuestionsByCandidate = 0; //是否每个候选人独立抽题
  useVirtualInterviewer?: 0; //是否使用虚拟面试官视频
  descAfter = ""; //结束说明（富文本）
  descAfterVideoCoverUrl = ""; //结束说明视频封面图链接
  descAfterVideoUrl = ""; //结束说明视频链接
  descBefore = ""; //面试须知（富文本）
  descBeforeVideoCoverUrl = ""; //面试须知视频封面图链接
  descBeforeVideoUrl = ""; //面试须知视频封面图
  privacyJumpUrl = ""; //隐私文案跳转链接
  privacyText = ""; //隐私文案富文本
  titleName = ""; //面试上的公司品牌名
  examLogoUrl = ""; //面试上的公司品牌LOGO图片链接
  publicityPageBgImgUrl = ""; //宣传页背景图片链接
  publicityPageContent = ""; //宣传页介绍富文本
  publicityPageVideoCoverUrl = ""; //宣传页视频封面图链接
  publicityPageVideoUrl = ""; // 宣传页视频链接
  paramList: StructParam[] = new Array<StructParam>(); //登记信息配置
  testExam = 2;
  autoAuditPassScore = 70;
  autoAuditRefuseScore = 30;
  testExamId = 0; //测试用考试id
  remark = ""; //面试备注
  useAutoAudit = 2;
  colorTest = 2; //色盲检测
  fingerTest = 2; //手指检测
  bodyCheckTest = 2; //形体检测
  psychologicalTest = 2; // 心理测评
  bgCheckProductId = 0; //背调产品ID，0表示不配置
  useAutoAuditByAiRecommendStatus = 0; // AI推荐
  vipLevel = 0; // vip等级 0免费 10付费

  public rules(): _.Dictionary<object[]> {
    return {
      name: [{ required: true, message: "请输入面试名称", trigger: "blur" }],
      startDate: [
        { required: true, message: "请选择面试开始时间", trigger: "blur" }
      ],
      endDate: [
        { required: true, message: "请选择面试结束时间", trigger: "blur" }
      ],
      autoAuditPassScore: [
        {
          required: true,
          message: `请填写分数，若不需要自动通过，可设置一个较大的分数`,
          trigger: "change"
        },
        {
          pattern: /^[0-9]\d*$|^-[0-9]\d*$/,
          message: "请输入整数",
          trigger: "change"
        },
        {
          trigger: "change",
          validator: (rule: unknown, value: string, callback: Function) => {
            if (Number(value) < 0) {
              return callback(new Error("自动通过的分数必须大于或等于0"));
            } else {
              callback();
            }
          }
        }
      ],
      autoAuditRefuseScore: [
        {
          required: true,
          message: `请填写分数，若不需要自动拒绝，可设置一个较小的负数`,
          trigger: "change"
        },
        {
          pattern: /^[0-9]\d*$|^-[0-9]\d*$/,
          message: "请输入整数",
          trigger: "change"
        }
        // {
        //   trigger: "change",
        //   validator: (rule: unknown, value: any, callback: Function) => {
        //     if (Number(value) > 70) {
        //       return callback(
        //         new Error("自动拒绝的分数必须小于或等于自动通过的分数")
        //       );
        //     } else {
        //       callback();
        //     }
        //   },
        // },
      ]
    };
  }
}

export class StructCompany {
  name = "";
  logoUrl = "";
}
export class StructCompanySpecialConfig {
  useNewUi = 0; // 是否使用新版UI
  preferWxmini = 0; // 是否倾向使用微信小程序
}

export class ExamQuestionRemoveForm extends ExamGetForm {
  questionId = 0;
}

export class CompanyIdParam {
  companyId = "0";
  examType = "";
}

export class StructExam extends StructExamUserData {
  examId = 0;
  connectCode = "";
  companyId = 0;
  userId = 0;
  // structExamUserData = new StructExamUserData();
  closeUpdate = 0;
  createTime = "";
  company = new StructCompany();
  companySpecialConfig = new StructCompanySpecialConfig();
  joinStatus = 0;
}

export class ExamInfo extends Model {
  examId = "";
  companyId = "";
  scoreAll = 0;
  name = "";
  closeUpdate = 0;
  questionList = [];
  questionCount = 0;
  candidateType = 0;
  connectCode = "";

  static getInfo(examId: string) {
    return request.post("onlineExam/exam/get", { examId }).then(resp => {
      return new ExamInfo().assign(resp.data.data);
    });
  }
}

export class CandidateCount extends Model {
  all = 0;
  audit = 0;
  pass = 0;
  submit = 0;
}

export default class ExamList extends Model {
  name = ""; //面试名称
  beginTime = ""; //面试有效期
  endTime = ""; //面试有效期
  timeStatus = 0; //面试状态
  connectCode = "";
  classification = 0; // 面试类型
  closeUpdate = 0;
  joinStatus = 0;
  canOpenJoin = 1; //是否允许公开邀请 默认1允许
  candidateCount: CandidateCount = new CandidateCount(); //候选人数据
  questionNumber = 0; // 题目数量
  optionNumber = 0; //考察项数量
  examId = 0; // 面试ID
  examIdForSetWeb = ""; // 面试批次id
  noEnding = 0;
  remark = "";
  subExamIdList: any = null;
  candidateNumber = 0; //候选人总数
  closeInviteCandidate = 0; //禁止添加候选人按钮 展示
  isRandomQuestions = 0; //抽题组卷
  ifAskPaper = 0; //是否开启问卷调查 1开
  createTime = ""; //创建时间
  lastUpdateTime = ""; //最后更新时间
  platformVersion = 0;
  scoreType = ""; // 计分方式 0 题目 1面试
  isNoCreateOpenJoin = 2;
  examVersionId = 0; // 新版中的批次ID

  statusName(status: number) {
    //面试状态
    switch (status) {
      case 1:
        return "进行中";
      case 2:
        return "未开始";
      case 3:
        return "已结束";
    }
  }

  // 获取面试列表数据
  static getList(listForm: ExamListForm) {
    listForm = { ...listForm, examType: V.getExamType };
    return request.post("aiExam/exam/list", listForm).then(resp => {
      const exams = new Array<ExamList>();
      const examsRes = {
        count: 0,
        exams: exams
      };
      if (resp.data.code === 0) {
        examsRes.count = resp.data.data.count;
        _.forEach(resp.data.data.list, item => {
          const exam = new ExamList();
          exam.assign(item);
          exams.push(exam);
        });
      }
      return examsRes;
    });
  }

  // 获取面试小程序二维码
  static wsaCode(examWsaParam: ExamGetForm) {
    return request.post("aiExam/exam/wsaCode", examWsaParam).then(resp => {
      return resp.data;
    });
  }

  static examGet(examGetForm: ExamGetForm) {
    return request.post("aiExam/exam/get", examGetForm).then(resp => {
      return resp.data.data;
    });
  }
  static examGetAi(examGetForm: ExamGetForm) {
    return request.post("aiExam/exam2/get", examGetForm).then(resp => {
      return resp.data.data;
    });
  }
  static examGetAiV3(examGetForm: ExamGetForm) {
    return request.post("aiExam/exam3/get", examGetForm).then(resp => {
      return resp.data.data;
    });
  }

  static examGetAll(examGetAllForm: ExamGetAllForm) {
    examGetAllForm = { ...examGetAllForm, examType: V.getExamType };
    return request.post("aiExam/company/examAll", examGetAllForm).then(resp => {
      return resp.data.data;
    });
  }

  static examReportGet(reportForm: ExamGetForm) {
    return request.post("aiExam/exam/report", reportForm).then(resp => {
      return resp.data.data;
    });
  }

  static examCreate(examCreateForm: ExamCreateForm) {
    return request.post("aiExam/exam/create", examCreateForm).then(resp => {
      return resp.data;
    });
  }

  static examUpdate(examUpdateForm: ExamUpdateForm) {
    return request.post("aiExam/exam/update", examUpdateForm).then(resp => {
      return resp.data;
    });
  }

  static examCopy(examCopyForm: ExamCopyForm) {
    return request.post("aiExam/exam/copy", examCopyForm).then(resp => {
      return resp.data;
    });
  }

  static examDelete(examDeleteForm: ExamDeleteForm) {
    return request.post("aiExam/exam/delete", examDeleteForm).then(resp => {
      return resp.data;
    });
  }
  static examDeleteAi(examDeleteForm: ExamDeleteForm) {
    return request.post("aiExam/exam2/delete", examDeleteForm).then(resp => {
      return resp.data;
    });
  }
  static examDeleteWorker(examDeleteForm: ExamDeleteForm) {
    return request.post("aiExam/exam3/delete", examDeleteForm).then(resp => {
      return resp.data;
    });
  }

  static getTestExams() {
    return request.post("aiExam/exam/testExams", {}).then(resp => {
      return resp.data;
    });
  }

  static examExportExel(exportParams: ExamGetForm) {
    return request.post("aiExam/exam/exportParams", exportParams).then(resp => {
      return resp.data;
    });
  }

  static getQuestionList(params: ExamGetForm) {
    return request.post("aiExam/examQuestions/get", params).then(resp => {
      return resp.data;
    });
  }

  static examQuestionRemove(params: ExamQuestionRemoveForm) {
    return request.post("aiExam/examQuestions/remove", params).then(resp => {
      return resp.data;
    });
  }

  static getCandidateList(candidateListForm: CandidateListForm) {
    if (candidateListForm.examType == "") {
      candidateListForm = {
        ...candidateListForm,
        examType: V.getExamType
      } as any;
    }
    return request
      .post("aiExam/candidate/list", candidateListForm)
      .then(resp => {
        return resp.data;
      });
  }

  static getCandidateListNew(params: any) {
    return request.post("aiExam/candidate/repeatList", params).then(resp => {
      return resp.data;
    });
  }
  //目前仅用于友达光电
  static getFskCandidateList(candidateListForm: CandidateListForm) {
    return request
      .post("aiExam/fsk/candidateList", candidateListForm)
      .then(resp => {
        return resp.data;
      });
  }

  //多人评估左侧列表
  static getManyHrCandidateList(candidateListForm: CandidateListForm) {
    return request
      .post("aiExam/judgePublic/candidateList", candidateListForm)
      .then(resp => {
        return resp.data;
      });
  }

  static getCandidateListIds(candidateListForm: CandidateListForm) {
    candidateListForm = {
      ...candidateListForm,
      examType: V.getExamType
    } as any;
    return request
      .post("aiExam/candidate/listIds", candidateListForm)
      .then(resp => {
        return resp.data;
      });
  }

  static candidateListExport(candidateListForm: CandidateListForm) {
    candidateListForm = {
      ...candidateListForm,
      examType: V.getExamType
    } as any;
    return request
      .post("aiExam/candidate/listExport", candidateListForm)
      .then(resp => {
        return resp.data;
      });
  }

  static candidateVideoListExport(candidateListForm: CandidateListForm) {
    candidateListForm = {
      ...candidateListForm,
      examType: V.getExamType
    } as any;
    return request
      .post("aiExam/candidate/videoUrlExport", candidateListForm)
      .then(resp => {
        return resp.data;
      });
  }

  static candidateMSetTags(candidateTagList: any) {
    return request
      .post("aiExam/candidate/mSetTags", candidateTagList)
      .then(resp => {
        return resp.data;
      });
  }

  static companyTags(companyIdParam: any) {
    companyIdParam = { ...companyIdParam, examType: V.getExamType };
    return request
      .post("aiExam/candidate/listFeatures", companyIdParam)
      .then(resp => {
        return resp.data;
      });
  }
  static getHrTags(params: any) {
    params = { ...params, examType: V.getExamType };
    return request
      .post("aiExam/auditPublic/listFeatures", params)
      .then(resp => {
        return resp.data;
      });
  }
  static setHrTags(params: any) {
    return request.post("aiExam/auditPublic/setTags", params).then(resp => {
      return resp.data;
    });
  }

  static examUrl(examGetForm: ExamGetForm) {
    return request.post("aiExam/exam/url", examGetForm).then(resp => {
      return resp.data;
    });
  }
  // 清空上传的HR评分
  static mAuditClear(params: any) {
    return request.post("aiExam/exam/mAuditClear", params).then(resp => {
      return resp.data;
    });
  }
  // 批量评分-提交
  static mAuditSubmit(params: any) {
    return request.post("aiExam/exam/mAuditSubmit", params).then(resp => {
      return resp.data;
    });
  }
  // 批量评分-解析
  static mAuditParse(params: any) {
    return request.post("/aiExam/exam/mAuditParse", params).then(resp => {
      return resp.data;
    });
  }
  // 批量评分-查询
  static mAuditCheck(params: any) {
    return request.post("/aiExam/exam/mAuditCheck", params).then(resp => {
      return resp.data;
    });
  }
}
